import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-my",
  "use": "icon-my-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-my\"><path d=\"M20,30 C12.2680135,30 6,23.7319865 6,16 C6,8.2680135 12.2680135,2 20,2 C27.7319865,2 34,8.2680135 34,16 C34,23.7319865 27.7319865,30 20,30 Z M20,27 C26.0751322,27 31,22.0751322 31,16 C31,9.92486775 26.0751322,5 20,5 C13.9248678,5 9,9.92486775 9,16 C9,22.0751322 13.9248678,27 20,27 Z M2,35 L38,35 L38,38 L2,38 L2,35 Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/my.svg
// module id = kY+R
// module chunks = 28